export default __webpack_public_path__ + "iphone-screen-detail-2f85a79989cfcea0afe703df80b5f718.png";